// extracted by mini-css-extract-plugin
module.exports = {"recentConversationsRoot":"RecentSidebar_recentConversationsRoot__rNRoq","moreButton":"RecentSidebar_moreButton__q35E3"};